import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class CompanyAPI {

  static ModelNo = 1;

  static get = (success, failure) => {
    fetch(Config.app.link + 'api/company/', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getLogo = (success, failure) => {
    fetch(Config.app.link + 'api/company/get-logo', new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static putLogo = (file, success, failure) => {
    new Promise(async (resolve) => {
      const res = await new Promise(resolve1 => {
        fetch(Config.app.link + 'api/company/put-logo', new Header('GET'))
        .then(res => {
          if(res.status === Const.Success200) { res.json().then(result => resolve1(result)); }
          else { res.json().then(er => failure(er)); }
        }).catch(er => failure(er));
      });
      const options = { method: 'PUT', body: file };
      await new Promise(resolve => fetch(res.logo, options).then(res => resolve(res)));
      resolve(true);
    })
    .then(res => success())
    .catch(er => failure(er));
  }
}

export default CompanyAPI;